<template>
    <div class="px-6">
        <h4>Année courante : {{ currentYear }}</h4>
            <ul>
                <li v-for="group in interventions['currentYear']" :key="group.id">
                    <h6>{{ group.intervention_type.name }}</h6>
                    <ul>
                        <li v-for="(month, monthKey) in group.planningInterventionPrevisions" :key="monthKey">
                            <u>{{ monthKey }}</u>
                            <ul>
                                <li v-for="(row, previsionKey) in month" :key="previsionKey">
                                        <div v-if="row.interventions.length > 0" class="flex items-center">

                                            <div class="float-left square-tooltip cursor-pointer" :class="statusIntervention(row.interventions[0]).color">
                                            </div>
                                            <small class="text-info cursor-pointer font-medium leading-none inline mx-1" v-if="row.interventions[0].id !== intervention.id" @mousedown="goToRoute($event, 'Intervention Details', {id: row.interventions[0].id})">
                                                {{ $moment(row.interventions[0].planningable.start_date).format('DD/MM/Y hh:mm') }}
                                            </small>
                                            <small class="text-info font-medium leading-none inline mx-1" v-else>
                                                {{ $moment(row.interventions[0].planningable.start_date).format('DD/MM/Y hh:mm') }}
                                            </small>
                                            <small>
                                                - {{ row.interventions[0].planningable.user.first_name }} - {{ hoursAndMinutes(row.interventions[0].duration) }}
                                            </small>
                                        </div>
                                    <small v-else> Non planifiée en {{ currentYear }}</small>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </ul>
        <h4>Année précédente : {{ previousYear }}</h4>
        <ul>
            <li v-for="group in interventions['previousYear']" :key="group.id">
                <h6>{{ group.intervention_type.name }}</h6>
                <ul>
                    <li v-for="(month, monthKey) in group.planningInterventionPrevisions" :key="monthKey">
                        <u>{{ monthKey }}</u>
                        <ul>
                            <li v-for="(row, previsionKey) in month" :key="previsionKey">
                                <div v-if="row.interventions.length > 0" class="flex items-center">
                                    <div class="float-left square-tooltip cursor-pointer" :class="statusIntervention(row.interventions[0]).color">
                                    </div>
                                    <small class="text-info cursor-pointer font-medium leading-none inline mx-1" @mousedown="goToRoute($event, 'Intervention Details', {id: row.interventions[0].id})">
                                        {{ $moment(row.interventions[0].planningable.start_date).format('DD/MM/Y hh:mm') }}
                                    </small>
                                    <small>
                                        - {{ row.interventions[0].planningable.user.first_name }} - {{ hoursAndMinutes(row.interventions[0].duration) }}
                                    </small>
                                </div>
                                <small v-else> Non planifiée en {{ previousYear }}</small>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
        </ul>

    </div>
</template>

<script>
import dateTimeFormattingMixin from '@/mixins/date-time-formatting-mixin'
import routerMixin from "@/mixins/router-mixin"

export default {
    name: "Panel",
    mixins: [ dateTimeFormattingMixin, routerMixin ],
    props: {
        intervention: {
            type: Object
        }
    },
    data() {
        return {
            currentYear: null,
            previousYear: null,
            interventions: []
        };
    },
    mounted() {
        this.getRelatedInterventionPlanning()
        this.currentYear = this.$moment(this.intervention.planification_date).year()
        this.previousYear = this.$moment(this.intervention.planification_date).subtract(1, 'year').year()
    },
    methods: {
        async getRelatedInterventionPlanning() {
            const { data } = await this.$store.dispatch('interventions/getRelatedInterventions', {
                    interventionId: this.intervention.id
                })
            this.interventions = data
        },
        statusIntervention(intervention) {
            let status = { text: intervention.status.name, color: '' }
            switch (intervention.status_id) {
                case 1:
                    status.color = 'danger'
                    break
                case 2:
                    status.color = 'warning'
                    break
                case 3:
                    status.color = 'yellow'
                    break
                case 4:
                    status.color = 'success'
                    break
                default:
                    status.color = 'black'
                    break
            }
            return status
        },
    }
}
</script>

<style scoped lang="scss">
.square-tooltip {
    width: 13px;
    height: 13px;
    border-radius: 3px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;

    &.danger {
         background-color: $brand-primary;
     }

    &.success {
         background-color: $brand-success;
     }

    &.warning {
         background-color: $brand-warning;
     }

    &.yellow {
         background-color: $yellow-A700;
     }

    &.black {
         background-color: $black;
     }

    span {
        font-size: .6rem;
        line-height: .9rem;
    }
}
</style>
